import { __assign, __awaiter, __generator } from "tslib";
import { CheckoutNavigationService } from '../../../services/CheckoutNavigationService/CheckoutNavigationService';
import { ModalType } from '../../../services/CheckoutNavigationService/constants';
export var getCheckoutEligibility = function (_a) {
    var context = _a.context;
    return function (checkoutDetails) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isPremium, delivery, canPay, isLiveSite, reason;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, context.eCommerceSettingsService.getEcommerceSettings()];
                case 1:
                    _a = _c.sent(), isPremium = _a.isPremium, delivery = _a.delivery;
                    canPay = !(checkoutDetails === null || checkoutDetails === void 0 ? void 0 : checkoutDetails.requirePayment) || /* istanbul ignore next */ true;
                    isLiveSite = !(context.siteStore.isPreviewMode() || context.siteStore.isEditorMode());
                    /* istanbul ignore else */
                    if (((_b = delivery.countries) === null || _b === void 0 ? void 0 : _b.length) === 0 && !delivery.restOfWorld && (checkoutDetails === null || checkoutDetails === void 0 ? void 0 : checkoutDetails.hasShippableItems)) {
                        reason = 'CannotShip';
                    }
                    else if (!canPay) {
                        reason = 'NoConnectedPaymentMethods';
                    }
                    else if (!isPremium) {
                        reason = 'NotPremium';
                    }
                    else if (!isLiveSite) {
                        reason = 'NotInLiveSite';
                    }
                    return [2 /*return*/, __assign({ canCheckout: !reason }, { reason: reason })];
            }
        });
    }); };
};
var OWNER_REASON_TO_MODAL_TYPE = {
    CannotShip: ModalType.SetShipping,
    NoConnectedPaymentMethods: ModalType.SetPayment,
    NotPremium: ModalType.UpgradeToPremium,
    NotInLiveSite: ModalType.NotInLiveSite,
};
var REASON_TO_MODAL_TYPE = {
    CannotShip: ModalType.NoOnlinePayments,
    NoConnectedPaymentMethods: ModalType.NoOnlinePayments,
    NotPremium: undefined,
    NotInLiveSite: undefined,
};
export var handleCheckoutEligibility = function (_a) {
    var context = _a.context;
    return function (checkoutEligibility, options) { return __awaiter(void 0, void 0, void 0, function () {
        var checkoutNavigationService, isOwnerOrNotInLiveSite, modalType, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkoutEligibility.reason) {
                        return [2 /*return*/, { canNavigateToCheckout: true }];
                    }
                    checkoutNavigationService = new CheckoutNavigationService(__assign(__assign({}, context), { origin: options.origin }));
                    isOwnerOrNotInLiveSite = context.siteStore.isOwner || context.siteStore.isPreviewMode() || context.siteStore.isEditorMode();
                    modalType = isOwnerOrNotInLiveSite
                        ? OWNER_REASON_TO_MODAL_TYPE[checkoutEligibility.reason]
                        : REASON_TO_MODAL_TYPE[checkoutEligibility.reason];
                    if (!modalType) {
                        return [2 /*return*/, { canNavigateToCheckout: true }];
                    }
                    return [4 /*yield*/, checkoutNavigationService.openLegacyCartModal(modalType, {}, true)];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, { canNavigateToCheckout: modalType === ModalType.UpgradeToPremium && Boolean(response === null || response === void 0 ? void 0 : response.proceed) }];
            }
        });
    }); };
};
//# sourceMappingURL=checkoutEligibility.js.map